import { ReactElement } from "react";

export const IndicatorSeparator = (): ReactElement => {
  return <span />;
};
